import { render, staticRenderFns } from "./AboutMobile.vue?vue&type=template&id=4bb3db8b&scoped=true"
import script from "./AboutMobile.vue?vue&type=script&lang=js"
export * from "./AboutMobile.vue?vue&type=script&lang=js"
import style0 from "./AboutMobile.vue?vue&type=style&index=0&id=4bb3db8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3db8b",
  null
  
)

export default component.exports